export const getUpcomingDate = (day: number, locale: string) => {
  const now = new Date();

  const createDate = (year: number, month: number) => {
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    const normalizedDay = Math.min(day, lastDayOfMonth);
    return new Date(year, month, normalizedDay);
  };

  let nextDate = createDate(now.getFullYear(), now.getMonth());
  if (nextDate <= now) {
    nextDate = createDate(now.getFullYear(), now.getMonth() + 1);
  }

  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    day: 'numeric',
  }).format(nextDate);
};

export const ordinalDay = (day: number, countryCode: string) => {
  const remainderTen = day % 10;
  const remainderHundred = day % 100;

  if (countryCode === 'SE') {
    // Swedish: numbers ending in 1 or 2 take ":a", except 11/12; otherwise ":e".
    const suffix =
      (remainderTen === 1 || remainderTen === 2) &&
      remainderHundred !== 11 &&
      remainderHundred !== 12
        ? ':a'
        : ':e';
    return `${day}${suffix}`;
  }

  if (countryCode === 'NO' || countryCode === 'DK' || countryCode === 'FI') {
    return `${day}.`;
  }

  // English (and fallback).
  if (remainderTen === 1 && remainderHundred !== 11) return `${day}st`;
  if (remainderTen === 2 && remainderHundred !== 12) return `${day}nd`;
  if (remainderTen === 3 && remainderHundred !== 13) return `${day}rd`;
  return `${day}th`;
};
